/** IDs stored under `site_config.integrations.tracking` (public site). */
export type SiteTrackingConfig = {
  google_analytics_measurement_id?: string
  /** Google Ads / conversion tag (AW-…) — optional second gtag config. */
  google_ads_conversion_id?: string
  facebook_pixel_id?: string
  tiktok_pixel_id?: string
  snapchat_pixel_id?: string
}

export function readTrackingFromIntegrations(integrations: unknown): SiteTrackingConfig {
  if (!integrations || typeof integrations !== 'object') return {}
  const t = (integrations as { tracking?: unknown }).tracking
  if (!t || typeof t !== 'object') return {}
  const o = t as Record<string, unknown>
  const s = (x: unknown) => (typeof x === 'string' ? x.trim() : '')
  return {
    google_analytics_measurement_id: s(o.google_analytics_measurement_id) || undefined,
    google_ads_conversion_id: s(o.google_ads_conversion_id) || undefined,
    facebook_pixel_id: s(o.facebook_pixel_id) || undefined,
    tiktok_pixel_id: s(o.tiktok_pixel_id) || undefined,
    snapchat_pixel_id: s(o.snapchat_pixel_id) || undefined,
  }
}
